export default __webpack_public_path__ + "static/media/voucher.38cebbfb.svg";